/* Coastal Reflections — show a one-line note under the Frame selector when a
   framed option is selected AND the shopper is outside Australia.
   Country comes from Shopify Markets geolocation (window.Shopify.country).
   Preview override for testing: append ?cr_country=US to the product URL. */
(function () {
  var TEXT_HTML = '<strong>Framed prints: Australia only.</strong> ' +
    'Unframed ships to NZ, UK, Ireland, USA &amp; Canada.';
  var override = null;
  try { override = new URLSearchParams(window.location.search).get('cr_country'); } catch (e) {}
  var country = (override || (window.Shopify && window.Shopify.country) || 'AU').toUpperCase();
  if (country === 'AU') return;

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function frameField(vs) {
    var sets = vs.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && norm(lg.textContent) === 'frame') return { type: 'radio', el: sets[i] };
    }
    var wraps = vs.querySelectorAll('.product-form__input--dropdown, .product-form__input');
    for (var j = 0; j < wraps.length; j++) {
      var lab = wraps[j].querySelector('label');
      var sel = wraps[j].querySelector('select');
      if (lab && sel && norm(lab.textContent) === 'frame') return { type: 'select', el: sel };
    }
    return null;
  }

  function selectedFrame(f) {
    if (!f) return null;
    if (f.type === 'select') return f.el.value;
    var chk = f.el.querySelector('input[type="radio"]:checked');
    return chk ? chk.value : null;
  }

  function ensureNote(vs) {
    var n = document.querySelector('.cr-intl-note');
    if (!n) {
      n = document.createElement('p');
      n.className = 'cr-intl-note product__text';
      n.setAttribute('role', 'note');
      n.innerHTML = TEXT_HTML;
      n.hidden = true;
      vs.insertAdjacentElement('afterend', n);
    }
    return n;
  }

  var scheduled = false;
  function update() {
    scheduled = false;
    var vs = document.querySelector('variant-selects');
    if (!vs) return;
    var f = frameField(vs);
    if (!f) return;
    var v = selectedFrame(f);
    var n = ensureNote(vs);
    n.hidden = !v || norm(v) === 'unframed';
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || setTimeout)(update, 0);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) schedule();
  });
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
